/**
 * DragIndicatorAltIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const DragIndicatorAltIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M21 11H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2M3 8h18a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2m18 8H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const DragIndicatorAltIcon = makeIcon('DragIndicatorAltIcon', DragIndicatorAltIconSvg)
